const nonInteractiveSelector = '[data-readonly="true"], :disabled';

export const isNonInteractiveTarget = (target: unknown) => {
  if (!(target instanceof window.Element)) {
    return false;
  }

  if (target.closest(nonInteractiveSelector)) {
    return true;
  }

  return !!target.querySelector(nonInteractiveSelector);
};
